export const USER_ROLE = {
  ADMIN: 'admin',
  NORMAL: 'normal',
} as const;

export type UserRole = typeof USER_ROLE[keyof typeof USER_ROLE];

export const USER_ACCESS_LEVEL = {
  READ: 'read',
  WRITE: 'write',
} as const;

export type UserAccessLevel = typeof USER_ACCESS_LEVEL[keyof typeof USER_ACCESS_LEVEL];

export const USER_MANAGEMENT_TEXT = {
  TITLE: 'User Management',
  BUTTON_ADD_USER: 'Add User',
  BUTTON_CANCEL: 'Cancel',
  BUTTON_CREATE: 'Create',
  BUTTON_SAVE: 'Save',
  BUTTON_UPDATE: 'Update',
  DIALOG_CREATE_USER: 'Create New User',
  DIALOG_EDIT_USER_PREFIX: 'Edit User',
  DIALOG_CHANGE_PASSWORD: 'Change Password',
  TOOLTIP_EDIT_USER: 'Edit user',
  TOOLTIP_CHANGE_PASSWORD: 'Change password',
  PASSWORD_HELPER: 'Minimum 6 characters',
} as const;

export const USER_MANAGEMENT_FIELD_LABEL = {
  USERNAME: 'Username',
  PASSWORD: 'Password',
  NEW_PASSWORD: 'New Password',
  ROLE: 'Role',
  ACCESS_LEVEL: 'Access Level',
} as const;

export const USER_MANAGEMENT_TABLE_HEADER = {
  USERNAME: 'Username',
  ROLE: 'Role',
  ACCESS: 'Access',
  STATUS: 'Status',
  ACTIONS: 'Actions',
} as const;

export const USER_MANAGEMENT_TABLE_HEADERS = Object.values(USER_MANAGEMENT_TABLE_HEADER);

export const USER_ROLE_LABEL = {
  [USER_ROLE.NORMAL]: 'Normal',
  [USER_ROLE.ADMIN]: 'Admin',
} as const;

export const USER_ACCESS_LEVEL_LABEL = {
  [USER_ACCESS_LEVEL.READ]: 'Read Only',
  [USER_ACCESS_LEVEL.WRITE]: 'Read & Write',
} as const;

export const USER_ACCOUNT_STATUS_LABEL = {
  ACTIVE: 'Active',
  DISABLED: 'Disabled',
} as const;

export const USER_ACCOUNT_TOGGLE_LABEL = {
  ACTIVE: 'Account Active',
  DISABLED: 'Account Disabled',
} as const;

export const USER_MANAGEMENT_MESSAGE = {
  LOAD_FAILED: 'Failed to load users',
  CREATE_SUCCESS: 'User created successfully',
  CREATE_FAILED: 'Failed to create user',
  UPDATE_SUCCESS: 'User updated successfully',
  UPDATE_FAILED: 'Failed to update user',
  PASSWORD_UPDATE_SUCCESS: 'Password updated successfully',
  PASSWORD_UPDATE_FAILED: 'Failed to update password',
  USERNAME_ALREADY_EXISTS: 'Username already exists',
} as const;
